function setupCountryProvinceSelector(
  countrySelectElementId,
  provinceSelectElementId,
  hideElementId
) {
  if (Shopify && Shopify.CountryProvinceSelector) {
    // eslint-disable-next-line no-new
    new Shopify.CountryProvinceSelector(
      countrySelectElementId,
      provinceSelectElementId,
      {
        hideElement: hideElementId,
      }
    );
  }
}

function Address() {
  _setupCountries();
  _setupEventListeners();
}

function _setupCountries() {
  if (Shopify && Shopify.CountryProvinceSelector) {
    setupCountryProvinceSelector(
      "AddressCountryNew",
      "AddressProvinceNew",
      "AddressProvinceContainerNew"
    );

    elements.countrySelects.forEach((select) => {
      const formId = select.dataset.formId;
      setupCountryProvinceSelector(
        `AddressCountry_${formId}`,
        `AddressProvince_${formId}`,
        `AddressProvinceContainer_${formId}`
      );
    });
  }
}

document.addEventListener("DOMContentLoaded", function () {
  Address();
});
